import { Card, Empty, Flex, List, Typography } from 'antd';

const { Text } = Typography;

const TopProductInCartMobile = ({ viewModel }) => {
  const { dataSource } = viewModel;

  if (!dataSource?.length) {
    return <Empty description='Chưa có dữ liệu' />;
  }

  return (
    <List
      split={false}
      dataSource={dataSource}
      renderItem={(record, index) => {
        const productName = record?.product?.name || 'Sản phẩm';
        const variantName = record?.variant?.variant_title || '';
        const quantity = record?.quantity || 0;

        return (
          <List.Item style={{ padding: '6px 0' }}>
            <Card style={{ width: '100%' }} bodyStyle={{ padding: 12 }}>
              <Flex vertical gap={2}>
                <Text >{`${index + 1}. ${productName}`}</Text>
                {variantName ? <Text type='secondary'>{variantName}</Text> : null}
                <Flex justify='flex-end'>
                  <Text>{`Số lượng: ${quantity}`}</Text>
                </Flex>
              </Flex>
            </Card>
          </List.Item>
        );
      }}
    />
  );
};

export default TopProductInCartMobile;
